const subscribeFormQuery = () => gql`
    query subscribeFormContext($id: String!, $contentType: String!) {
        subscribeFormContext(id: $id, contentType: $contentType) {
            data
        }
    }
`;

export default subscribeFormQuery;
